import { message, Spin, Switch, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { useEffect, useState } from 'react';
import moment from 'moment';
import {
  NachWebhookDashboardRequestPayload,
  updateURLStatusConfigMapping,
  getSourceUrlMapping,
} from 'api/nach';
import { Link } from 'react-router-dom';

// Declare the missing ResponseResource and DashboardModel types
export type DashboardModel<T> = {
  data: T[];
  noOfRecords: number;
  currentPageIndex?: number;
};

export type ResponseResource<T> = {
  responseCode: number;
  message: string;
  status: string;
  data: T;
};

type TableDataItem = NachWebhookDashboardRequestPayload;

type Props = {};

const Applevellist = ({ }: Props) => {
  const [pagedList, setPagedList] = useState<DashboardModel<TableDataItem> | null>(null);
  const [isTableLoading, setIsTableLoading] = useState(true);

  const [updatingId, setUpdatingId] = useState<number | string | null>(null);

  useEffect(() => {
    setPagedList(null);
    setIsTableLoading(true);
    debugger;
    getSourceUrlMapping({ pageNo: 1 })
      .then((res) => {
        setPagedList(res.data);
      })
      .catch((error: any) => {
        console.error('Error fetching data:', error);
        message.error('Failed to load data.');
      })
      .finally(() => {
        setIsTableLoading(false);
      });
  }, []);

  // const handleUpdate = async (record: TableDataItem, checked: boolean) => {
  //   debugger;
  //   const newIsActive = checked;

  //   const payload: NachWebhookDashboardRequestPayload = {
  //     sourceId: record.sourceId,
  //     status: record.status,
  //     statusId: record.statusId,
  //     isActive: newIsActive,
  //     sourceConfigId: record.sourceConfigId,
  //     statusConfigId: record.statusConfigId,
  //   };

  //   try {
  //     await updateURLStatusConfigMapping(payload);
  //     message.success(
  //       `Status updated to ${newIsActive === true ? 'Active' : 'Inactive'} successfully!`
  //     );
  //     // Optimistically update the table state instead of refetching all data
  //     setPagedList((prevList) => {
  //       if (!prevList) return null;

  //       const updatedData = prevList.data.map((item) =>
  //         item.statusConfigId === record.statusConfigId ? { ...item, active: newIsActive } : item
  //       );

  //       return { ...prevList, data: updatedData };
  //     });
  //   } catch (error: any) {
  //     console.error('Update failed:', error);
  //     message.error('Update failed. Please try again.');
  //   }
  // };

  const handleUpdate = async (record: TableDataItem, checked: boolean) => {
    // 2. Prevent multiple clicks for the same row
    setUpdatingId(record.statusConfigId ?? null);
    const payload: NachWebhookDashboardRequestPayload = {
      sourceId: record.sourceId,
      status: record.status,
      statusId: record.statusId,
      isActive: checked,
      sourceConfigId: record.sourceConfigId,
      statusConfigId: record.statusConfigId,
    };

    try {
      await updateURLStatusConfigMapping(payload);

      // 3. Destroy previous messages so they don't stack
      message.destroy();
      message.success(`Status updated to ${checked ? 'Active' : 'Inactive'} successfully!`);

      setPagedList((prevList) => {
        if (!prevList) return null;
        const updatedData = prevList.data.map((item) =>
          item.statusConfigId === record.statusConfigId ? { ...item, active: checked } : item
        );
        return { ...prevList, data: updatedData };
      });
    } catch (error: any) {
      message.error('Update failed. Please try again.');
    } finally {
      // 4. Release the lock
      setUpdatingId(null);
    }
  };

  const columns: ColumnsType<TableDataItem> = [
    // {
    //   key: 'sourceApplicationName',
    //   title: 'Source Application Name',
    //   dataIndex: 'sourceApplicationName',
    //   ellipsis: true,
    //   render: (record) => (
    //     <Tooltip placement="topLeft" title={record}>
    //       {record}
    //     </Tooltip>
    //   ),
    // },
    {
      key: 'sourceApplicationName',
      title: 'Source Application Name',
      dataIndex: 'sourceApplicationName',
      ellipsis: true,
      render: (text, record) => (
        <Tooltip placement="topLeft" title={text || ''}>
          <Link to="/nach/webhook_nach_master/updatewebhookurl" state={record}>
            {text || ''}
          </Link>
        </Tooltip>
      ),
    },
    {
      key: 'status',
      title: 'Mandate Status',
      dataIndex: 'status',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'configURL',
      title: 'Config URL',
      dataIndex: 'configURL',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'createdOn',
      title: 'Created On',
      dataIndex: 'createdOn',
      ellipsis: true,
      render: (text) => {
        if (moment(text).isValid()) {
          const formattedDate = moment(text).format('YYYY-MM-DD hh:mm:ss');
          return (
            <Tooltip placement="topLeft" title={formattedDate}>
              {formattedDate}
            </Tooltip>
          );
        }
        return text;
      },
    },
    // {
    //   key: 'action',
    //   title: 'Action',
    //   fixed: 'right',
    //   width: 100,
    //   render: (_, record) => (
    //     <Switch
    //       checked={record?.active ?? true} // Use nullish coalescing to provide a default value
    //       onChange={(checked) => handleUpdate(record, checked)}
    //       checkedChildren="Active"
    //       unCheckedChildren="Inactive"
    //     />
    //   ),
    // },
    {
      key: 'action',
      title: 'Action',
      fixed: 'right',
      width: 100,
      render: (_, record) => (
        <Switch
          loading={updatingId === record.statusConfigId} // Shows a spinner on the switch
          disabled={updatingId !== null} // Optional: Disable all switches while one is updating
          checked={record?.active ?? true}
          onChange={(checked) => handleUpdate(record, checked)}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },
  ];

  if (!pagedList) {
    return <LoadingScreen />;
  }

  // const handleChange = (pagination: any) => {
  //   setIsTableLoading(true);
  //   const apiFilter = {
  //     pageNo: pagination.current,
  //     pageSize: pagination.pageSize,
  //   };
  //   debugger;
  //   getSourceUrlMapping(apiFilter)
  //     .then((res: any) => {
  //       // Assuming res.data contains { data, noOfRecords, currentPageIndex }
  //       if (res.data && res.data.data) {
  //         setPagedList(res.data);
  //       } else {
  //         message.error('Invalid data received from API.');
  //       }
  //     })
  //     .catch((error: any) => {
  //       console.error('Error fetching data:', error);
  //       message.error('Failed to load data.');
  //     })
  //     .finally(() => {
  //       setIsTableLoading(false);
  //     });
  // };

  const handleChange = (pagination: any) => {
    setIsTableLoading(true);

    // 1. Force clear the data so the 6 old records disappear immediately
    setPagedList((prev) => (prev ? { ...prev, data: [] } : null));

    const apiFilter = {
      // 2. Sync Index: If your Java code uses (pageNo, pageSize),
      // and you see 4 records on "Page 2", ensure the backend isn't
      // actually seeing (Offset 10, Limit 10).
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    };

    getSourceUrlMapping(apiFilter)
      .then((res: any) => {
        if (res.data && res.data.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsTableLoading(false);
      });
  };

  const maxWidthPerCell = 1000;
  const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'sourceId';

  // return (
  //   <Spin spinning={isTableLoading}>
  //     <Table
  //       columns={dataTable.columns}
  //       dataSource={pagedList.data}
  //       rowKey={rowKey}
  //       scroll={{ x: dataTable.tableWidth, y: tableHeight }}
  //       pagination={{
  //         pageSize: 10, // Or pagedList.pageSize
  //         total: pagedList.noOfRecords,
  //         current: pagedList.currentPageIndex === 0 ? 1 : pagedList.currentPageIndex,
  //       }}
  //       onChange={handleChange}
  //     />
  //   </Spin>
  // );

  return (
    <Spin spinning={isTableLoading}>
      <Table
        columns={dataTable.columns}
        dataSource={pagedList.data} // The 4 records from API
        rowKey={rowKey} // Ensure 'sourceId' is unique for every record
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        pagination={{
          pageSize: 10,
          total: pagedList.noOfRecords,
          // Use the value exactly as returned by the API
          current: pagedList.currentPageIndex,
        }}
        onChange={handleChange}
      />
    </Spin>
  );
};

export default Applevellist;
